/**
 * ShareAgentMenu: the "Share" button under the message box of a team conversation. It opens the same list as the Agents page: for each of your
 * agents, who may use it and who covers the tokens. Every change leaves a line in the thread.
 */
import React, { useEffect, useRef, useState } from 'react';
import { Share2, X } from 'lucide-react';
import { T } from './teamUi.jsx';
import MyAgentsShareList from './MyAgentsShareList.jsx';

export default function ShareAgentMenu({ spaceId }) {
  const [open, setOpen] = useState(false);
  const box = useRef(null);
  useEffect(() => {
    if (!open) return undefined;
    const close = (e) => { if (box.current && !box.current.contains(e.target)) setOpen(false); };
    document.addEventListener('mousedown', close);
    return () => document.removeEventListener('mousedown', close);
  }, [open]);

  return (
    <span ref={box} style={{ position: 'relative', display: 'inline-flex' }}>
      <button type="button" onClick={() => setOpen((v) => !v)} title="Share one of your agents with this team"
        style={{ display: 'inline-flex', alignItems: 'center', gap: 5, padding: '5px 10px', borderRadius: 8, background: open ? T.accentLight : T.surface2, border: `1px solid ${open ? T.accentMid : T.border}`, cursor: 'pointer', fontSize: 12, color: open ? T.accent : T.ink3, fontFamily: 'inherit' }}>
        <Share2 size={12} /> Share
      </button>
      {open && (
        <div role="dialog" aria-label="Share an agent with this team"
          style={{ position: 'absolute', left: 0, bottom: 'calc(100% + 8px)', width: 520, maxWidth: '88vw', maxHeight: 420, overflowY: 'auto', background: T.surface, border: `1px solid ${T.border}`, borderRadius: 14, boxShadow: '0 12px 30px rgba(0,0,0,0.14)', zIndex: 120 }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: 8, padding: '12px 14px 4px' }}>
            <b style={{ fontSize: 13, color: T.ink }}>Share an agent with this team</b>
            <button type="button" onClick={() => setOpen(false)} aria-label="Close" style={{ marginLeft: 'auto', border: 'none', background: 'none', cursor: 'pointer', color: T.ink4, display: 'flex' }}><X size={14} /></button>
          </div>
          <div style={{ fontSize: 11.5, color: T.ink3, lineHeight: 1.5, padding: '0 14px 8px' }}>It runs with your own access. The team owner can always block it.</div>
          <MyAgentsShareList spaceId={spaceId} compact />
        </div>
      )}
    </span>
  );
}
